module.exports = __webpack_public_path__ + "static/media/client.58994cf6.svg";